import { createStandardAction } from 'typesafe-actions';

const CHANGE_FAQ = 'faq/CHANGE_FAQ';
const REQUEST_CHANGE_FAQ = 'faq/REQUEST_CHANGE_FAQ';
const SET_OPACITY = 'faq/SET_OPACITY';

export const changeFAQ = createStandardAction(CHANGE_FAQ)<number>();
export const requestChangeFAQ = createStandardAction(REQUEST_CHANGE_FAQ)<
  number
>();
export const setOpacity = createStandardAction(SET_OPACITY)<boolean>();



// WEBPACK FOOTER //
// ./src/store/modules/faq/actions.ts